<!-- <div class="header-wrapper" fxLayout="column" fxLayoutGap="1em">-->
<!--  <div class="header-container"-->
<!--       fxLayout="row"-->
<!--       fxLayoutAlign="space-between"-->
<!--       fxLayout.lt-md="column"-->
<!--       fxFlexAlign="center"-->
<!--       style="width: 60%;align-self: center">-->
<!--    <div class="logo-container" fxFlexAlign="center center" fxLayout="column">-->
<!--      <img src="/assets/images/logo.png" alt="" fxFlex.lt-md="50px" fxFlex="70px">-->
<!--    </div>-->
<!--    <div class="contact-us" fxLayout="row" fxFlex="1 1 45" fxLayout.lt-md="column" fxLayoutAlign.lt-md="flex-start"  fxLayoutAlign="space-around center">-->
<!--      <app-text-icon-box-->
<!--        [link]="'tel:+972506880102'"-->
<!--        [text]="'התקשר אלינו:'"  [value]="'+972506880102'" icon="phone"></app-text-icon-box>-->
<!--      <div class="header-divider"></div>-->
<!--      <app-text-icon-box-->
<!--        link="mailto:orders@slickchain.com"-->
<!--        text='שלח דוא"ל'  [value]="'orders@slickchain.com'" icon="mail"></app-text-icon-box>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="site-menu-wrapper" fxLayout="row" fxLayout.lt-md="column" style="width: 60%;align-self: center">-->
<!--    <div class="site-menu-container" style="align-self: center" fxFlex="1 0 60%" fxFlexAlign="center" fxLayout.lt-md="column" fxLayout="" fxLayoutAlign="space-between center">-->
<!--      <app-site-menu [user]="user" fxFlex="auto"></app-site-menu>-->
<!--      <div class="user-status" style="color: white" fxLayout="row" fxLayoutGap="1em" fxFlex="0 1 auto"  >-->
<!--        <ng-container *ngIf="!user.isLogin">-->
<!--          <span routerLink="/auth/register">הרשם</span>-->
<!--          <span routerLink="/auth/login">התחבר</span>-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="user.isLogin">-->
<!--          <app-user-login-section [user]="user.userData"></app-user-login-section>-->
<!--        </ng-container>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div> -->
<div class="header-wrapper" fxLayout="row" fxFlex="">
  <div class="header-container" fxLayout="row wrap" fxFlex="">
    <div class="first-line" fxLayout="row" fxLayoutGap="1em" style="align-items: center !important;">
      <div class="logo-container" fxLayout="row" fxFlex="none" fxFlex.lt-md="100" fxLayoutAlign="flex-end center"
        fxLayoutGap="3em">
        <div class="mobile-menu-icon" fxHide="true" fxShow.lt-md="true" (click)="onMenuClick(true)">
          <mat-icon style="color: white;font-size: 32px ">menu</mat-icon>
        </div>
        <div class="logo-cont" fxFlex.lt-md="80%" fxFlex="none"
          style="max-width: 400px; height: auto; margin-left: 2em;padding-top:10px;">
          <img src="/assets/images/logo.png" alt="">
        </div>
        <div class="logo-cont accessibility-link" fxFlex.lt-md="80%" fxFlex="none">
            <i *ngIf="!isUAERoute && localeService.israeliMarket" class='fas fa-wheelchair'></i>
            <a *ngIf="!isUAERoute && localeService.israeliMarket" href="#" routerLink="/AccesabilityStatement">{{ 'HEADER.ACCESSIBILITY_STATEMENT' | translate }}</a>
        </div>
      </div>
      <div class="contact-us" fxLayout="row" fxFlex="45" fxFlex.lt-md="100" fxShow.lt-md="false"
        fxLayoutAlign.lt-md="flex-start" fxLayoutAlign="start center">
        <app-text-icon-box *ngIf="!isUAERoute && localeService.israeliMarket" [link]="'tel:+972506880102'" [text]=""
          [value]="'+972506880102'" icon="phone"></app-text-icon-box>
        <app-text-icon-box *ngIf="isUAERoute" [link]="'tel:+971585873808'" [text]="" [value]="'+971585873808'"
          icon="phone"></app-text-icon-box>
        <div class="header-divider"></div>
        <app-text-icon-box *ngIf="!isUAERoute" link="mailto:orders@slickchain.com" text=''
          [value]="'orders@slickchain.com'" icon="mail"></app-text-icon-box>
        <app-text-icon-box *ngIf="isUAERoute" link="mailto:orders@slickchain.com" text=''
          [value]="'orders@slickchain.com'" icon="mail"></app-text-icon-box>
      </div>

    <div class="avatar-container">
      <div class="avatar" fxLayout="row" fxLayoutGap="1em" fxFlex="">
        <div class="language-switcher" *ngIf="localeService.showLanguageSelector && !isNigeriaRoute">
          <i class="fas fa-globe"></i>
          <select [(ngModel)]="currentLanguage" (ngModelChange)="switchLanguage($event)">
            <option *ngFor="let lang of getAvailableLanguages()" [ngValue]="lang">
              {{ getLanguageDisplayName(lang) }}
            </option>
          </select>
        </div>

        <div class="currency-switcher" *ngIf="isOrdersListRoute">
          <i class="fas fa-coins"></i>
          <ng-select class="currency-ng"
                     [items]="getCurrencyOptions()"
                     [(ngModel)]="currentCurrency"
                     (ngModelChange)="switchCurrency($event)"
                     [clearable]="false">
          </ng-select>
        </div>

        <ng-container *ngIf="user.isLogin">
          <app-user-login-section [user]="user.userData"></app-user-login-section>
          <ng-container *ngIf="login$|async as ls">
            <ng-container *ngIf="notifications$|async as notifications">
              <span class="p-overlay-badge" [routerLink]="['/account/notifications']">
                <i class="pi pi-bell"></i>
                <span class="p-badge" *ngIf="notifications.length">{{notifications.length}}</span>
              </span>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>

    </div>
    <div class="menu-line" fxShow.lt-md="false" fxLayout="row" fxLayoutAlign=" center">


      <div class="user-status" fxLayout="row" fxLayoutGap="0.5em" fxFlex=""
        fxLayoutAlign="flex-end center">
        <ng-container *ngIf="!user.isLogin">
          <span *ngIf="!isUAERoute || isNigeriaRoute" routerLink="/auth/login" (click)="openDialog()" class="nav-btn login-btn">
            <i class="fas fa-sign-in-alt"></i>{{ 'HEADER.LOGIN' | translate }}
          </span>
          <span *ngIf="!isUAERoute || isNigeriaRoute" routerLink="/auth/register" class="nav-btn signup-btn">
            <i class="fas fa-user-plus"></i>{{ 'HEADER.SIGNUP' | translate }}
          </span>
        </ng-container>
      </div>
       <div class="site-menu">
        <app-site-menu [user]="user" fxFlex="10" fxLayoutAlign="start stretch"  style="white-space: nowrap; color:white">
        </app-site-menu>
      </div>

    </div>


  </div>


  <p-toast>
    <ng-template let-message pTemplate="message">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <span>{{message.summary}}</span>
          <p>{{message.detail}}</p>
        </div>
        <a [routerLink]="['/subscribe']" *ngIf="message.id === 'subscribe'">{{ 'HEADER.SUBSCRIBE' | translate }}</a>
      </div>
    </ng-template>
  </p-toast>
</div>
